import TitleView from '@plone/volto/components/manage/Blocks/Title/View';
import cx from 'classnames';
import Breadcrumbs from '@plone/volto/components/theme/Breadcrumbs/Breadcrumbs';
import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  public: {
    id: 'Public Event',
    defaultMessage: 'Public Event',
  },
  nonpublic: {
    id: 'Non-Public Event',
    defaultMessage: 'Non-Public Event',
  },
});

const EventHeaderTemplate = (props) => {
  const { content } = props;
  const intl = useIntl();

  return (
    <div className={cx('block pageheader', props.className)}>
      <div className="event-header">
        <div className="event-text-image-wrapper">
          <div className="event-text">
            <div className="event-suffix-heading">
              {!content?.public && (
                <span>{intl.formatMessage(messages.nonpublic)}</span>
              )}
              {content?.taxonomy_event_type?.map((taxo) => (
                <span key={taxo.token}>{taxo.title} </span>
              ))}
              {content?.taxonomy_topics?.map((taxo) => (
                <span key={taxo.token}>{taxo.title} </span>
              ))}
            </div>
            <h1 className="documentFirstHeading event-name-heading">
              {content.title}
            </h1>
            {content?.description && (
              <p className="event-description">{content.description}</p>
            )}
          </div>
        </div>
      </div>
      {props.breadcrumbPath && (
        <div className="pageheader-breadcrumbs">
          <Breadcrumbs pathname={props.breadcrumbPath} />
        </div>
      )}
    </div>
  );
};

export default EventHeaderTemplate;
